import { setTrackingId } from "client/Misc/utils";
import {
	PropsWithChildren,
	ReactElement,
	Ref
} from "react";
import styles from "./HubGridViewLayout.module.less";

export const HubGridViewLayout = (props: PropsWithChildren<{}>): ReactElement => (
	<div className={styles.root}>
		{props.children}
	</div>
);
HubGridViewLayout.displayName = "HubGridViewLayout";

export type HubGridViewLayoutListProps = {
	ref?: Ref<HTMLUListElement>;
	trackingId: string;
};

const HubGridViewLayoutList = (props: PropsWithChildren<HubGridViewLayoutListProps>): ReactElement => {
	const {
		children,
		trackingId,
		ref
	} = props;

	return (
		<ul
			{...setTrackingId(trackingId)}
			className={styles.list}
			ref={ref}
		>
			{children}
		</ul>
	);
};
HubGridViewLayoutList.displayName = "HubGridViewLayout.List";

const HubGridViewLayoutListItem = (props: PropsWithChildren<{}>): ReactElement => {
	const {
		children
	} = props;

	return (
		<li>
			{children}
		</li>
	);
};
HubGridViewLayoutListItem.displayName = "HubGridViewLayout.ListItem";

HubGridViewLayout.List = HubGridViewLayoutList;
HubGridViewLayout.ListItem = HubGridViewLayoutListItem;
